var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accommodation-price-input"},[_c('v-text-field',{attrs:{"label":"Platsavgift","outlined":"","hide-details":"auto","type":"number","append-icon":"coi-currency-sek"},model:{value:(_vm.priceInput),callback:function ($$v) {_vm.priceInput=$$v},expression:"priceInput"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }